module.exports = __webpack_public_path__ + "static/img/recordstart.0d74466.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meetingcontrol/black/recordstart.png
// module id = eEuC
// module chunks = 1